<template>
  <div class="flex w-screen h-screen flex-col items-center justify-center">
    <figure>
      <img src="/images/logo-light.webp" alt="Logo" class="size-full object-cover" />
      <span class="sr-only">{{ props.app.title }}</span>
    </figure>
  </div>
</template>

<script setup lang="ts">
import type { PageProps } from '@public/ts/types/shared'

const props = defineProps<PageProps>()
</script>
